"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.couponUsableApi = couponUsableApi;
exports.creditsAddApi = creditsAddApi;
exports.creditsDeleteApi = creditsDeleteApi;
exports.creditsListApi = creditsListApi;
exports.creditsUpdateApi = creditsUpdateApi;
exports.creditsUpdateShowApi = creditsUpdateShowApi;
exports.getMemberConsumeTrendDataApi = getMemberConsumeTrendDataApi;
exports.getMemberNewTrendDataApi = getMemberNewTrendDataApi;
exports.getMemberOverviewDataApi = getMemberOverviewDataApi;
exports.getMemberStatisticsMomDataApi = getMemberStatisticsMomDataApi;
exports.memberBenefitsListApi = memberBenefitsListApi;
exports.memberBenefitsSaveApi = memberBenefitsSaveApi;
exports.memberLevelAddApi = memberLevelAddApi;
exports.memberLevelDeleteApi = memberLevelDeleteApi;
exports.memberLevelDistributionApi = memberLevelDistributionApi;
exports.memberLevelListApi = memberLevelListApi;
exports.memberLevelUpdateApi = memberLevelUpdateApi;
exports.merchantAgreementInfoApi = merchantAgreementInfoApi;
exports.merchantAgreementSaveApi = merchantAgreementSaveApi;
exports.merchantShippingRefundAuditApi = merchantShippingRefundAuditApi;
exports.merchantShippingRefundInfoApi = merchantShippingRefundInfoApi;
exports.orderStatisticsChartApi = orderStatisticsChartApi;
exports.orderStatisticsShippingApi = orderStatisticsShippingApi;
exports.orderStatisticsTopApi = orderStatisticsTopApi;
exports.orderStatisticsTypeApi = orderStatisticsTypeApi;
exports.shippingCreditsRefundListApi = shippingCreditsRefundListApi;
exports.shippingOrderApi = shippingOrderApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 会员权益列表
function memberBenefitsListApi() {
  return (0, _request.default)({
    url: '/admin/merchant/member/benefits/list',
    method: 'get'
  });
}

// 会员权益保存
function memberBenefitsSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/member/benefits/save',
    method: 'post',
    data: data
  });
}

// 会员等级列表
function memberLevelListApi() {
  return (0, _request.default)({
    url: '/admin/merchant/member/level/list',
    method: 'get'
  });
}

// 会员等级新增
function memberLevelAddApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/member/level/add',
    method: 'post',
    data: data
  });
}

// 会员等级编辑
function memberLevelUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/member/level/update',
    method: 'post',
    data: data
  });
}

// 会员等级删除
function memberLevelDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/member/level/delete/".concat(id),
    method: 'post'
  });
}

// 购物金套餐添加
function creditsAddApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/shipping/credits/package/add",
    method: 'post',
    data: data
  });
}

// 购物金套餐删除
function creditsDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/shipping/credits/package/delete/".concat(id),
    method: 'post'
  });
}

// 购物金套餐列表
function creditsListApi() {
  return (0, _request.default)({
    url: "/admin/merchant/shipping/credits/package/list",
    method: 'get'
  });
}

// 购物金套餐编辑
function creditsUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/shipping/credits/package/update",
    method: 'post',
    data: data
  });
}

// 购物金套餐显示状态变更
function creditsUpdateShowApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/shipping/credits/package/update/show/".concat(id),
    method: 'post'
  });
}

// 会员等级分布统计
function memberLevelDistributionApi() {
  return (0, _request.default)({
    url: '/admin/merchant/member/level/distribution',
    method: 'get'
  });
}

// 购物金订单分页列表
function shippingOrderApi(params) {
  var data = _objectSpread({}, params);
  delete data.dateLimitAttr;
  return (0, _request.default)({
    url: '/admin/merchant/shipping/credits/order/page',
    method: 'get',
    params: data
  });
}

// 折线趋势图统计
function orderStatisticsChartApi() {
  return (0, _request.default)({
    url: '/admin/merchant/order/statistics/chart',
    method: 'get'
  });
}

// 订单发货统计
function orderStatisticsShippingApi() {
  return (0, _request.default)({
    url: '/admin/merchant/order/statistics/shipping',
    method: 'get'
  });
}

// 顶部核心数据统计
function orderStatisticsTopApi() {
  return (0, _request.default)({
    url: '/admin/merchant/order/statistics/top',
    method: 'get'
  });
}

// 订单类型统计
function orderStatisticsTypeApi() {
  return (0, _request.default)({
    url: '/admin/merchant/order/statistics/type',
    method: 'get'
  });
}

// 购物金退款订单分页列表
function shippingCreditsRefundListApi(params) {
  var data = _objectSpread({}, params);
  delete data.dateLimitAttr;
  return (0, _request.default)({
    url: '/admin/merchant/shipping/credits/refund/order/page',
    method: 'get',
    params: data
  });
}

// 商户会员开卡协议详情
function merchantAgreementInfoApi() {
  return (0, _request.default)({
    url: '/admin/merchant/agreement/member/card/open/info',
    method: 'get'
  });
}

// 商户会员开卡协议保存
function merchantAgreementSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/agreement/member/card/open/save',
    method: 'post',
    data: data
  });
}

// 购物金退款订单详情
function merchantShippingRefundInfoApi(refundOrderNo) {
  return (0, _request.default)({
    url: "admin/merchant/shipping/credits/refund/order/info/".concat(refundOrderNo),
    method: 'get'
  });
}

// 购物金退款订单详情
function merchantShippingRefundAuditApi(data) {
  return (0, _request.default)({
    url: "admin/merchant/shipping/credits/refund/order/audit",
    method: 'post',
    data: data
  });
}

// 获取会员环比数据
function getMemberStatisticsMomDataApi(params) {
  return (0, _request.default)({
    url: "admin/merchant/member/statistics/mom/data",
    method: 'get',
    params: params
  });
}

// 获取会员概览数据
function getMemberOverviewDataApi() {
  return (0, _request.default)({
    url: "admin/merchant/member/statistics/overview",
    method: 'get'
  });
}

// 获取会员新增趋势数据
function getMemberNewTrendDataApi(params) {
  return (0, _request.default)({
    url: "admin/merchant/member/statistics/new/trend/data",
    method: 'get',
    params: params
  });
}

// 获取会员消费趋势数据
function getMemberConsumeTrendDataApi(params) {
  return (0, _request.default)({
    url: "admin/merchant/member/statistics/consume/trend/data",
    method: 'get',
    params: params
  });
}

// 商户会员可用优惠券列表
function couponUsableApi() {
  return (0, _request.default)({
    url: "admin/merchant/coupon/member/usable/list",
    method: 'get'
  });
}